import React from 'react';
import ReactMarkdown from 'react-markdown';
import AppFooter from '../../../../../components/Footer';
import {
  footer as footerStyle,
  categoryDescription as categoryDescriptionStyle,
} from './styles.module.css';

const Footer = ({ description }) => {
  return (
    <>
      {description && (
        <div className={categoryDescriptionStyle}>
          <ReactMarkdown source={description} />
        </div>
      )}

      <div className={footerStyle}>
        <AppFooter narrow />
      </div>
    </>
  );
};

export default Footer;
